var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"sandbox":"allow-scripts allow-top-navigation allow-same-origin","scrolling":"no","width":"300","height":"400","frameBorder":"0","allowTransparency":"true","src":_vm.setSrc}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282f7d66","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/vue-wxlogin/vue-wxlogin.vue
// module id = null
// module chunks = 